import { useMutation as e } from "@maat/store-hooks";
import { aiApi as t } from "@maat/api-ai";
//#region src/ai/useSubmitAiRatingMutation.ts
var n = () => e({ mutationFn: ({ generationId: e, rating: n, comment: r }) => t.submitRating(e, {
	rating: n,
	comment: r
}) });
//#endregion
export { n as useSubmitAiRatingMutation };
